import {MODULE4DEMODATA, MODULE4DEMOSETTINGS,} from "../../../config/mock";
import * as actionTypes from "../../actions/actionTypes";
import {updateObject} from "../../shared/utility";

interface IUserPreference {
  [key: string]: {
    id: string
    value: any
  }
}
const initialState = {
  userPreferences: {
    activepage: { id: '', value: '0' },
    activestep: { id: '', value: '0' },
    title: { id: '', value: '' },

    comparecontent: { id: '', value: false },
    identifyimprove: { id: '', value: false },
    learnparticipants: { id: '', value: false },
    notsure: { id: '', value: false },

    heardofus: { id: '', value: '' },
    other: { id: '', value: '' },
    hassensor: { id: '', value: '' },
    kind: { id: '', value: '' },
    model: { id: '', value: '' },

    module1s1: { id: '', value: false },
    module1s2: { id: '', value: false },
    module1s3: { id: '', value: false },
    module1s4: { id: '', value: false },
    module1s5: { id: '', value: false },
    module1s6: { id: '', value: false },
    module1finish: { id: '', value: false },

    pickvideoinfo: { id: '', value: '' },

    calendlyevent: { id: '', value: false },

    videoplayed: { id: '', value: false },
    tagtoggled: { id: '', value: false },
    compared: { id: '', value: false },
    youtube: {id: '', value: ''},
    creatoronboard: { id: '', value: false },
    module4Data: { id: '', value: MODULE4DEMODATA },
  },
  page: 0,
  prevPage: -1,
  is_loaded: false,
  lastPreference: {
    id: '',
    title: '',
    value: ''
  },
  // module4Data: MODULE4DEMODATA,

  module4Settings: MODULE4DEMOSETTINGS,
};

const DEFINITIONS = [
  { title: 'activepage', name: 'ACTIVEPAGE', initial: '0' },
  { title: 'activestep', name: 'ACTIVESTEP', initial: '0' },
  { title: 'title', name: 'TITLE', initial: '' },

  { title: 'comparecontent', name: 'COMPARECONTENT', initial: false },
  { title: 'identifyimprove', name: 'IDENTIFYIMPROVE', initial: false },
  { title: 'learnparticipants', name: 'LEARNPARTICIPANTS', initial: false },
  { title: 'notsure', name: 'NOTSURE', initial: false },

  { title: 'heardofus', name: 'HEARDOFUS', initial: '' },
  { title: 'other', name: 'OTHER', initial: '' },
  { title: 'hassensor', name: 'HASSENSOR', initial: '' },
  { title: 'kind', name: 'KIND', initial: '' },
  { title: 'model', name: 'MODEL', initial: '' },

  { title: 'module1s1', name: 'MODULE1S1', initial: false },
  { title: 'module1s2', name: 'MODULE1S2', initial: false },
  { title: 'module1s3', name: 'MODULE1S3', initial: false },
  { title: 'module1s4', name: 'MODULE1S4', initial: false },
  { title: 'module1s5', name: 'MODULE1S5', initial: false },
  { title: 'module1s6', name: 'MODULE1S6', initial: false },
  { title: 'module1finish', name: 'MODULE1FINISH', initial: false },

  { title: 'pickvideoinfo', name: 'PICKVIDEOINFO', initial: '' },

  { title: 'calendlyevent', name: 'CALENDLYEVENT', initial: false },

  { title: 'videoplayed', name: 'VIDEOPLAYED', initial: false },
  { title: 'tagtoggled', name: 'TAGTOGGLED', initial: false },
  { title: 'compared', name: 'COMPARED', initial: false },
  { title: 'youtube', name: 'ONBOARDING_YOUTUBE', initial: '' },
  { title: 'module4Data', name: 'MODULE4DATA', initial: MODULE4DEMODATA },

  { title: 'creatoronboard', name: 'CREATORONBOARD', initial: false },
];

const reducer = (state = { ...initialState }, action: any) => {
  switch (action.type) {

    case actionTypes.CREATOR_ON_BOARDING_GET_SUCCESS:
      const userPreference: IUserPreference = {};

      DEFINITIONS.forEach((x) => {
        if (x.name === 'MODULE4DATA') {
          userPreference[x.title] = {
            id: action.payload.find((item: any) => item.preference_name === x.name)?.preference_id || '',
            value: (action.payload.find((item: any) => item.preference_name === x.name)
              ? JSON.parse(action.payload.find((item: any) => item.preference_name === x.name).preference_information)
              : x.initial)
          }
        } else {
          userPreference[x.title] = {
            id: action.payload.find((item: any) => item.preference_name === x.name)?.preference_id || '',
            value:
              x.initial !== false
                ? action.payload.find((item: any) => item.preference_name === x.name)?.preference_information || x.initial
                : (action.payload.find((item: any) => item.preference_name === x.name)?.preference_information) === 'true' || x.initial,
          }
        }
      });

      return updateObject(state, {
        userPreferences: userPreference,
        is_loaded: true,
      });

    case actionTypes.CREATOR_ON_BOARDING_UPDATE_SUCCESS:
      return updateObject(state, {
        lastPreference: action.payload,
        is_loaded: false,
      });

    case actionTypes.CREATOR_ON_BOARDING_NEXT_PAGE:
      const pageData: {
        prevPage?: number;
        page?: number;
      } = {};
      pageData.prevPage = state.page;
      pageData.page = action.payload;
      return updateObject(state, pageData);

    case actionTypes.CREATOR_ONBOARDING_GET_BRAINTRUSTLIST_SUCCESS:
      return updateObject(state, {
        braintrustList: action.payload,
      });

    case actionTypes.UPDATE_ONBOARDING_SETTINGS:
      return updateObject(state, {
        module4Settings: {
          ...state.module4Settings, [action.payload.name]: action.payload.value
        }
      });

    default:
      return state;
  }
};

export default reducer;
